export default {
  "name": "NCForm",
  "column": 1,
  "canAppend": false,
  "type": 1,
  "path": "LowCodeComponents.NCForm",
  "label": "表单",
  "schema": {
    "type": "object",
    "properties": {
      "moduleId": {
        "title": "区域编码",
        "description": "区域编码",
        "type": "string"
      },
      "visible": {
        "title": "是否可见",
        "description": "是否可见",
        "type": "boolean"
      }
    },
    "required": [
      "moduleId"
    ]
  },
  "uiSchema": {},
  "slots": []
}